import {createColumnHelper} from '@tanstack/react-table'

const columnHelper = createColumnHelper()

export const listaRaportowColumns = [
    columnHelper.accessor('id', {
            header: 'ID',
            enableColumnFilter: false,
        },
    ),
    {accessorFn: (row) => row.nazwa, header: 'Nazwa'},
    {accessorFn: (row) => row.status, header: 'Status'},
    {
        accessorFn: (row) => {
            return row.valid === 1 ? 'Tak' : 'Nie'
        }, header: 'Czy zwalidowany'
    },
    {accessorFn: (row) => row.user_email, header: 'Utowrzone przez: email'},


]